import selection from '../../../../Template/config/components/selection'
import setBuilder from './SetBuilder'
import search from './Search'

export default {
    ...selection,
    search,
    setBuilder
}


// WEBPACK FOOTER //
// ./src/app/configuration/Discover/config/components/selection/index.js